/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { IDeviceCameraHealth, IDeviceComponentHealth } from '../../models/device-health.interface';

export interface IDeviceHealthState {
  devices: IDeviceHealth[];
  devicesHealthLoading: boolean;
  selectedVehicleId: string;
  totalDeviceIssues: number;
}

export interface IDeviceHealth {
  hostType: string;
  accountId: number;
  vehicleId: string;
  healthStatus: string;
  componentHealth: IDeviceComponentHealth[] | null;
  cameraHealth: IDeviceCameraHealth[] | null;
}

export const initialDeviceHealthState: IDeviceHealthState = {
  devices: [],
  devicesHealthLoading: false,
  selectedVehicleId: '',
  totalDeviceIssues: 0
};
